import { OK } from 'http-status-codes';
import { put, takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { actions, types } from './duck';

export function* getCJDeals({ params }) {
  try {
    yield put(actions.getCJDealsRequest());
    const response = yield api.getCJDeals(params);

    if (response.status === OK) {
      yield put(actions.getCJDealsSuccess(response.data.deals));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCJDealsFailure(error.message));
  }
}

export function* getCJAdvertisers() {
  try {
    yield put(actions.getCJAdvertisersRequest());
    const response = yield api.getCJAdvertisers();

    if (response.status === OK) {
      yield put(actions.getCJAdvertisersSuccess(response.data.advertisers));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCJAdvertisersFailure(error.message));
  }
}

export function* getCJProductImages({ params }) {
  try {
    yield put(actions.getCJProductImagesRequest());
    const response = yield api.getCJProductImages(params);

    if (response.status === OK) {
      yield put(actions.getCJProductImagesSuccess(response.data.images));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCJProductImagesFailure(error.message));
  }
}

export function* getCJSaleProducts({ params }) {
  try {
    yield put(actions.getCJSaleProductsRequest());
    const response = yield api.getCJSaleProducts(params);

    if (response.status === OK) {
      yield put(actions.getCJSaleProductsSuccess(response.data.products));
    } else {
      throw new Error(response.statusText);
    }
  } catch (error) {
    yield put(actions.getCJSaleProductsFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.GET_CJ_DEALS, getCJDeals);
  yield takeLatest(types.GET_CJ_ADVERTISERS, getCJAdvertisers);
  yield takeLatest(types.GET_CJ_PRODUCT_IMAGES, getCJProductImages);
  yield takeLatest(types.GET_CJ_SALE_PRODUCTS, getCJSaleProducts);
}